import React, {useEffect, useState} from 'react';
import LigneHorizontal from "../Composants/LigneHorizontal";


const Overlay = ({titre, children, onClose, width = "264px", footer, className}) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 100); // Ajoutez un délai ici (par exemple, 100ms)

        return () => clearTimeout(timer); // Nettoyage du timeout pour éviter les fuites de mémoire
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 400); // Wait for the animation to complete before closing
    };

    return (
        <div className={`overlay ${isVisible ? 'slide-in' : 'slide-out'} ${className ?? ''}`} style={{width: width}}>
            <div className={'blockTitre'}>
                <div className={"titre"}>{titre}</div>
                <div className={"forwardArrow"}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                         onClick={handleClose}>
                        <path d="M10.2373 7.16016L14.8819 12.0004L10.2373 16.8406" stroke="#70787B" strokeWidth="2"/>
                        <line x1="14.6973" y1="12.3301" x2="2.43556" y2="12.3301" stroke="#70787B" strokeWidth="2"/>
                        <line x1="19.0479" y1="5.39844" x2="19.0479" y2="18.6044" stroke="#70787B" strokeWidth="2"/>
                    </svg>
                </div>
            </div>
            <div className="overlay-content">
                <LigneHorizontal/>
                {children}
            </div>
            {footer && (
                <div className="overlay-footer">
                    {footer}
                </div>
            )}
        </div>
    );
};

export default Overlay;
